import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
const problems = ['Sientes que la IA es solo un juguete caro o una promesa vacía porque no logras que entienda exactamente lo que tienes en la cabeza.', 'Te han dicho que necesitas saber código o comprar "megapacks" de 10,000 prompts que nunca sirven para tu caso específico.', 'Estás atrapado en la mediocridad de los resultados automáticos.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-800/30 border-y border-white/5" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-130">
            El Problema Real
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-131">
            La mayoría de la gente usa la IA por "ensayo y error". Escriben un
            comando, reciben basura, se frustran y terminan haciendo el trabajo
            manualmente.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-4" data-id="element-132">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-6 rounded-2xl bg-navy-900 border border-red-500/20 hover:border-red-500/40 transition-colors" data-id="element-133">
              <div className="flex-shrink-0 mt-1" data-id="element-134">
                <AlertTriangleIcon className="w-6 h-6 text-red-400" data-id="element-135" />
              </div>
              <p className="ml-4 text-lg text-gray-300" data-id="element-136">{problem}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}